import { render, staticRenderFns } from "./DeviceCost.vue?vue&type=template&id=3b7bc9a8&scoped=true"
import script from "./DeviceCost.vue?vue&type=script&lang=js"
export * from "./DeviceCost.vue?vue&type=script&lang=js"
import style0 from "./DeviceCost.vue?vue&type=style&index=0&id=3b7bc9a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7bc9a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b7bc9a8')) {
      api.createRecord('3b7bc9a8', component.options)
    } else {
      api.reload('3b7bc9a8', component.options)
    }
    module.hot.accept("./DeviceCost.vue?vue&type=template&id=3b7bc9a8&scoped=true", function () {
      api.rerender('3b7bc9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeviceAccounts/DeviceCost.vue"
export default component.exports